export const SET_CONFIG = 'SET_CONFIG';

export const CLEAN_CONFIG_STORE = 'CLEAN_CONFIG_STORE';
